const TERMS_STORAGE_KEY = 'termsAccepted';
const TERMS_DATE_KEY = 'termsAcceptedDate';
const TERMS_VERSION = '1.0.0';

export const hasAcceptedTerms = () => {
  const accepted = localStorage.getItem(TERMS_STORAGE_KEY);
  const savedVersion = localStorage.getItem('termsVersion');
  
  if (accepted === 'true' && savedVersion !== TERMS_VERSION) {
    localStorage.removeItem(TERMS_STORAGE_KEY);
    localStorage.removeItem(TERMS_DATE_KEY);
    localStorage.removeItem('termsVersion');
    return false;
  }
  
  return accepted === 'true';
};

export const acceptTerms = () => {
  localStorage.setItem(TERMS_STORAGE_KEY, 'true');
  localStorage.setItem(TERMS_DATE_KEY, new Date().toISOString());
  localStorage.setItem('termsVersion', TERMS_VERSION);
};

export const getTermsVersion = () => TERMS_VERSION;